
import type { Optional } from 'apprise-core/utils'
import { useLanguage } from "./language"
import { utils } from 'apprise-core/utils'
import { Multilang } from 'apprise-core/common'
import { allLanguages, Language } from 'apprise-core/language'



export const useL = () => useMultilang().l

export const useMultilang = () => {

    const lang = useLanguage()

    const { purge, arrayOf } = utils()


    const self = {


        join: (ts: Optional<string | Multilang>[], separator: string = ' ') =>

            purge(arrayOf(ts)).map(t => (typeof t === 'string' ? t : self.l(t))?.trim()).join(separator)

        ,


        l: (ml: Optional<Multilang>) => ml ? (ml?.[lang.current()] ?? ml?.[lang.default()]) : undefined

        ,

        comparator: (m1: Optional<Multilang>, m2: Optional<Multilang>) => (self.l(m1) ?? '').localeCompare(self.l(m2) ?? '')

        ,


        test: (ml: any): ml is Multilang => !!ml && typeof ml === 'object' && Object.keys(ml).every(k => allLanguages.includes(k as Language))

    }


    return self

}